import { BbotModal } from "top-component-library";

// Mirrors archive-bos-dialog.html/archiveBOSDialogController.
const ArchiveBosDialog = ({ visible, hostname, customerName, onCancel, onConfirm }) => (
  <BbotModal title={`Archive ${hostname}`} visible={visible} onCancel={onCancel} okText="Confirm" onOk={onConfirm}>
    <p>
      Please press confirm below if you wish to archive this BOS. Archiving a BOS means it will no longer be live and it
      will no longer be accessible via the BOS Builder.
    </p>
    <p>
      Only {customerName} will be able to un-archive this BOS back to its original state. This is done simply by adding
      it again via the BOS Settings page. If unarchived, the site will be live again and all previous BOS Builder
      templates will be available.
    </p>
    <p>
      Other customers will be able to take new ownership of {hostname} after it is archived. However, any previously
      connected assets, locations, and customers will be wiped.
    </p>
  </BbotModal>
);

export default ArchiveBosDialog;
